import { render, staticRenderFns } from "./Fixed.vue?vue&type=template&id=f97d6718&scoped=true&"
import script from "./Fixed.vue?vue&type=script&lang=js&"
export * from "./Fixed.vue?vue&type=script&lang=js&"
import style0 from "./Fixed.vue?vue&type=style&index=0&id=f97d6718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97d6718",
  null
  
)

export default component.exports